import { render, staticRenderFns } from "./QualityTesting.vue?vue&type=template&id=b71fc24c&scoped=true"
import script from "./QualityTesting.vue?vue&type=script&lang=js"
export * from "./QualityTesting.vue?vue&type=script&lang=js"
import style0 from "./QualityTesting.vue?vue&type=style&index=0&id=b71fc24c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71fc24c",
  null
  
)

export default component.exports